import get from 'lodash/get';

// eslint-disable-next-line import/prefer-default-export
export const BT_DEPOSITACCOUNTS_SET_DATES = (state, { accountType, endDate, id, startDate }) => ({
  ...state,
  pickerDates: {
    [accountType]: {
      ...get(state, `pickerDates.${accountType}`, []),
      [id]: {
        startDate,
        endDate
      }
    }
  }
});
